import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-servidor-inativo',
  templateUrl: './servidor-inativo.component.html',
  styleUrls: ['./servidor-inativo.component.scss']
})
export class ServidorInativoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
